import { Component } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DialogUtil } from '../../../utils/dialog-utils';
import { KeywordsAndConstants } from '../../../core/keywords-and-constants';
import { LocalStorageService } from '../../../network/services/local-storage.service';
import { CommonModule } from '@angular/common';
import { StringVariable } from '../../../core/string-variable';

@Component({
  selector: 'app-under-maintenance-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './under-maintenance-modal.component.html',
  styleUrls: ['./under-maintenance-modal.component.scss'],
})
export class UnderMaintenanceModalComponent {
  errorCode: number | undefined;
  message: string | undefined;
  remainingTime: number = 20;
  setTimmer: boolean = false;
  serverDownMessage: boolean = false;

  constructor(
    private modalService: BsModalService,
    public dialog: DialogUtil,
    public constants: KeywordsAndConstants,
    public _service: LocalStorageService,
    public variable: StringVariable,
  ) {}

  ngOnInit(): void {
    if (this.errorCode == 503001) {
      this.setTimmer = true;
    } else if (!this.errorCode) {
      this.remainingTime = 60;
      this.setTimmer = true;
    } else {
      this.serverDownMessage = true;
    }
    if (this.setTimmer) {
      let interval = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.modalService.hide();
          localStorage.setItem(
            this.constants.isModalOpen,
            JSON.stringify(false)
          );
          var val = localStorage.getItem(this.constants.isModalOpen);
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  logout() {
    this._service.logout();
    this.modalService.hide();
  }
}
